"use strict";
import _ from "underscore";
import classNames from "classnames";
import Account from "../api/account";
import activityFormatter from "../formatters/activity";
import generalFormatter from "../formatters/general";
import factorInvoicesService from "./factor_invoices_service";
import SimpleHtmlFormat from "./simple_html_format";
import { Link } from "react-router";
import Auth from "../util/auth";
import DisablingButton from "../components/disabling_button";
import Transmissions from "../api/transmissions";
import React from "react";
import { assertType } from "./data/types/type_utilities";
const SentToCadenceActions = React.createClass(
  assertType({
    getInitialState() {
      return {
        sending: false,
        sent: false,
        isUnapproved: false
      };
    },
    componentDidMount() {
      const factorInvoice = factorInvoicesService.getFetchedWithId(
        this.props.item.owner_id
      );
      const isUnapproved = factorInvoice.state != "approved" && factorInvoice.state != "purchased";
      this.setState({ isUnapproved });
    },
    componentDidUpdate(prevProps) {
      if (this.props.item.owner_id !== prevProps.item.owner_id) {
        this.setState({ sent: false, sending: false });
      }
    },
    render() {
      const cadenceSuffix = `to CADENCE`;
      const buttonText = `Resend ${this.props.baseText} ${cadenceSuffix}`;
      const disabledText = `Resending ${this.props.baseText} ${cadenceSuffix}`;
      const sentText = `Resent ${this.props.baseText} ${cadenceSuffix}`;
      if (this.state.sent) {
        return /* @__PURE__ */ React.createElement("div", { className: "message--resent-to-cadence" }, sentText);
      } else if (this.state.isUnapproved) {
        return /* @__PURE__ */ React.createElement("div", { className: "message--resent-to-cadence" }, "Invoices have been un-approved and cannot be resent until re-approved");
      } else {
        return /* @__PURE__ */ React.createElement("div", { "data-component": "SentToCadenceActions" }, /* @__PURE__ */ React.createElement(
          DisablingButton,
          {
            disabledClassName: "button--disabled button--resend-to-cadence",
            className: "button--progress button--resend-to-cadence",
            onClick: this.send,
            disabled: this.state.sending,
            disabledText
          },
          buttonText
        ));
      }
    },
    send() {
      const component = this;
      this.setState({ sending: true });
      Transmissions.resend(this.props.item.data.transmission_id).then(() => {
        component.setState({ sending: false, sent: true });
      });
    }
  })
);
const ApprovalActions = React.createClass({
  getInitialState() {
    return {
      unapproving: false,
      unapproved: false,
      purchased: false,
      useSendToReceivables: false,
      sendingToReceivables: false
    };
  },
  componentDidMount() {
    const factorInvoice = factorInvoicesService.getFetchedWithId(
      this.props.item.owner_id
    );
    const isUnapproved = factorInvoice.state != "approved" && factorInvoice.state != "purchased";
    const isPurchased = factorInvoice.state == "purchased";
    const useSendToReceivables = Account.useSendToReceivables() && !factorInvoice.fuel_advance;
    this.setState({
      unapproved: isUnapproved,
      purchased: isPurchased,
      useSendToReceivables
    });
  },
  render() {
    const buttonText = `Un-approve ${this.props.baseText}`;
    const disabledText = `Un-approving ${this.props.baseText}`;
    const unapprovedText = `Un-approved ${this.props.baseText}`;
    if (this.state.unapproved) {
      return /* @__PURE__ */ React.createElement("div", { className: "message--resent-to-cadence" }, unapprovedText);
    } else if (this.state.purchased) {
      return /* @__PURE__ */ React.createElement("div", { className: "message--resent-to-cadence" }, "This invoice has been marked as purchased. Contact support to un-approve.");
    } else {
      return /* @__PURE__ */ React.createElement("div", { "data-component": "ApprovalActions" }, this.showUnapproveButton(buttonText, disabledText), this.sendToReceivablesButtonIf(this.state.useSendToReceivables));
    }
  },
  showUnapproveButton(buttonText, disabledText) {
    return /* @__PURE__ */ React.createElement(
      DisablingButton,
      {
        disabledClassName: "button--disabled button--resend-to-cadence",
        className: "button--progress button--resend-to-cadence",
        onClick: this.unapprove,
        disabled: this.state.unapproving,
        disabledText
      },
      buttonText
    );
  },
  sendToReceivablesButtonIf(useSendToReceivables) {
    if (useSendToReceivables) {
      return /* @__PURE__ */ React.createElement(
        DisablingButton,
        {
          disabledClassName: "button--disabled button--resend-to-cadence",
          className: "button--progress button--resend-to-cadence",
          onClick: this.sendToReceivables,
          disabled: this.state.sendingToReceivables,
          disabledText: "Sending to Receivables...."
        },
        "Mark as Purchased and Send to Receivables"
      );
    }
  },
  unapprove() {
    const component = this;
    this.setState({ unapproving: true });
    factorInvoicesService.unapproveInvoice(this.props.item.owner_id).then(() => {
      component.setState({ unapproving: false, unapproved: true });
    });
  },
  sendToReceivables() {
    const component = this;
    this.setState({ sendingToReceivables: true });
    factorInvoicesService.markInvoiceAsPurchased(this.props.item.owner_id).then(() => {
      component.setState({ sendingToReceivables: false, purchased: true });
    });
  }
});
const SentToBrokerTMSActions = React.createClass({
  getInitialState() {
    return {
      sending: false,
      sent: false
    };
  },
  render() {
    const baseText2 = `this invoice`;
    const buttonText = `Resend ${baseText2}`;
    const disabledText = `Resending ${baseText2}`;
    const sentText = `Resent ${baseText2}`;
    if (this.state.sent) {
      return /* @__PURE__ */ React.createElement("div", { className: "message--resent-to-cadence" }, sentText);
    } else {
      return /* @__PURE__ */ React.createElement("div", { "data-component": "SentToBrokerTMSActions" }, /* @__PURE__ */ React.createElement(
        DisablingButton,
        {
          disabledClassName: "button--disabled button--resend-to-cadence",
          className: "button--progress button--resend-to-cadence",
          onClick: this.send,
          disabled: this.state.sending,
          disabledText
        },
        buttonText
      ));
    }
  },
  send() {
    const component = this;
    this.setState({ sending: true });
    Transmissions.resend(this.props.item.data.transmission_id).then(() => {
      component.setState({ sending: false, sent: true });
    });
  }
});
function value(props, state) {
  if (state.expanded) {
    return props.value;
  } else {
    return /* @__PURE__ */ React.createElement("span", { className: "activity-item__detail-line-code-collapsed" }, "Click to show", /* @__PURE__ */ React.createElement("span", { className: "activity-item__detail-line-code-collapsed-period" }, "."));
  }
}
const ExpandableCodeElement = React.createClass({
  // eslint-disable-line no-restricted-syntax -- Legacy React.createClass - to be migrated
  getInitialState: function() {
    return {
      expanded: false
    };
  },
  toggle: function() {
    this.setState({ expanded: !this.state.expanded });
  },
  render: function() {
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        "data-component": "ExpandableCodeElement",
        className: "activity-item__detail-line-code-value",
        onClick: this.toggle
      },
      /* @__PURE__ */ React.createElement("code", null, value(this.props, this.state))
    );
  }
});
function possibleBody(body) {
  if (body) {
    return /* @__PURE__ */ React.createElement("div", { className: "activity-item__detail-full-body" }, /* @__PURE__ */ React.createElement(SimpleHtmlFormat, { text: body }));
  }
}
function detailLink(element) {
  return /* @__PURE__ */ React.createElement("div", null, "\u201C", /* @__PURE__ */ React.createElement(Link, { to: element.url }, element.value), "\u201D");
}
function showValueDetail(element) {
  return /* @__PURE__ */ React.createElement("div", { className: "activity-item__detail-line-value" }, element.url ? element.newTab ? /* @__PURE__ */ React.createElement("a", { href: element.url, target: "_blank", rel: "noopener noreferrer" }, element.value) : detailLink(element) : element.value);
}
function showLabel(label) {
  return /* @__PURE__ */ React.createElement("div", { className: "activity-item__detail-line-label" }, label);
}
var ActivityItemDetails = React.createClass({
  // eslint-disable-line no-restricted-syntax -- Legacy React.createClass - to be migrated
  render: function() {
    return /* @__PURE__ */ React.createElement("div", { className: "activity-item__detail-labeled-elements", "data-component": "ActivityItemDetails" }, _.map(
      this.props.formattedItem.labeled_elements,
      this.showLabeledElement
    ), possibleBody(this.props.formattedItem.body));
  },
  showCodeDetail: function(element) {
    const copyToClipboard = (str) => {
      const el = document.createElement("textarea");
      el.value = str;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      element.hasBeenCopied = true;
      this.setState({ copied: true });
    };
    const message = element.hasBeenCopied ? "Data copied!" : "Copy to clipboard";
    return /* @__PURE__ */ React.createElement("div", { className: "activity-item__detail-line-code-wrapper" }, /* @__PURE__ */ React.createElement(
      "button",
      {
        className: "button button--link",
        onClick: (_2) => copyToClipboard(element.code)
      },
      message
    ), /* @__PURE__ */ React.createElement(ExpandableCodeElement, { value: element.code }));
  },
  showLabeledElement: function(element, index) {
    const detail = element.code ? this.showCodeDetail(element) : showValueDetail(element);
    return /* @__PURE__ */ React.createElement("div", { className: "activity-item__detail-line", key: "labeled-item-" + index }, element.hasOwnProperty("label") && showLabel(element.label), detail);
  }
});
function othersText(item) {
  const data = item.data;
  const othersCount = data.invoice_count - 1;
  const othersPlural = othersCount === 1 ? "other" : "others";
  return othersCount === 0 || isNaN(othersCount) ? "" : ` and ${othersCount} ${othersPlural} `;
}
function baseText(item) {
  return `this invoice ${othersText(item)}`;
}
function showApprovalActions(item) {
  return item.activity_type === "approval" && item.owner_type === "FactorInvoice" && Auth._currentUser.admin;
}
function showSendToCadenceActions(item) {
  return item.activity_type === "sent_to_cadence" && item.data.transmission_type === "cadence" && Auth._currentUser.admin;
}
function showSendToBrokerTMSActions(item) {
  return item.data && item.data.transmission_id && item.data.transmission_type != "cadence" && item.data.transmission_type != "turvo_make_payment" && Auth._currentUser.admin;
}
function possibleActions(item) {
  if (showSendToCadenceActions(item)) {
    return /* @__PURE__ */ React.createElement(SentToCadenceActions, { item, baseText: baseText(item) });
  } else if (showSendToBrokerTMSActions(item)) {
    return /* @__PURE__ */ React.createElement(SentToBrokerTMSActions, { item });
  } else if (showApprovalActions(item)) {
    return /* @__PURE__ */ React.createElement(ApprovalActions, { item, baseText: baseText(item) });
  }
}
function showItem(item, index) {
  var formattedItem = activityFormatter.format(item);
  var hasDetail = formattedItem.labeled_elements && formattedItem.labeled_elements.length > 0 || formattedItem.body;
  var classes = classNames({
    "activity-item__container": true,
    "activity-item__container--detailed": hasDetail
  });
  return /* @__PURE__ */ React.createElement("div", { className: classes, key: "item-" + index }, /* @__PURE__ */ React.createElement("div", { className: "activity-item__body" }, /* @__PURE__ */ React.createElement("div", { className: "activity-item__meta" }, /* @__PURE__ */ React.createElement("div", { className: "activity-item__user" }, formattedItem.user_name || "Temp User"), /* @__PURE__ */ React.createElement("div", { className: "activity-item__timestamp" }, generalFormatter.shortDate(item.created_at), " ", generalFormatter.shortTime(item.created_at))), /* @__PURE__ */ React.createElement("div", { className: "activity-item__title" }, formattedItem.title), /* @__PURE__ */ React.createElement(ActivityItemDetails, { formattedItem }), possibleActions(item)));
}
function ActivityStream(props) {
  let detail;
  if (_.isEmpty(props.items)) {
    detail = /* @__PURE__ */ React.createElement("div", { className: "alert-box--highlight" }, "No Activity is available.");
  } else {
    detail = _.map(props.items, showItem);
  }
  return /* @__PURE__ */ React.createElement("div", { className: "activity-items", "data-component": "ActivityStream" }, detail);
}
export { ActivityStream };
